var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      width: "100%",
      display: "flex",
      "flex-direction": "column"
    },
    attrs: {
      id: "addNotice-root"
    }
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticClass: "table-page-search-wrapper"
  }, [_c("a-form-model", {
    ref: "searchForm",
    attrs: {
      layout: "inline",
      model: _vm.queryParam
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("arrivalNotice.noticeTitle"),
      prop: "noticeName",
      rules: [{
        required: true,
        message: _vm.$t("arrivalNotice.placeNoticeName"),
        trigger: "blur"
      }]
    }
  }, [_c("a-input", {
    attrs: {
      width: "200px",
      allowClear: true,
      placeholder: _vm.$t("publicuse.pleaseinput"),
      maxLength: 100,
      disabled: _vm.noticeSettingData && _vm.noticeSettingData.noticeflag === 1
    },
    model: {
      value: _vm.queryParam.noticeName,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "noticeName", $$v);
      },
      expression: "queryParam.noticeName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("arrivalNotice.sellerName"),
      prop: "selllerCode",
      rules: [{
        required: true,
        message: _vm.$t("arrivalNotice.placeSeller"),
        trigger: "blur"
      }]
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("publicuse.pleaseselect"),
      allowClear: "",
      mode: "multiple",
      maxTagCount: 2
    },
    model: {
      value: _vm.queryParam.selllerCode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "selllerCode", $$v);
      },
      expression: "queryParam.selllerCode"
    }
  }, _vm._l(_vm.sellerOptions, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.sellerCode
      }
    }, [_vm._v(" " + _vm._s(item.sellerName) + " ")]);
  }), 1)], 1)], 1)], 1)], 1)], 1)]), _c("a-card", {
    staticStyle: {
      "margin-top": "24px",
      position: "relative",
      flex: "1 1 0%"
    },
    attrs: {
      id: "table",
      bordered: false,
      title: _vm.$t("arrivalNotice.settingProduct")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "padding-left": "12px"
    }
  }, [!_vm.noticeSettingData || _vm.noticeSettingData && _vm.noticeSettingData.noticeflag !== 1 ? [_vm.productList.length == 0 ? _c("div", {
    staticStyle: {
      padding: "12px 0"
    }
  }, [_c("a", {
    on: {
      click: function click($event) {
        return _vm.addProduct();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("arrivalNotice.productAdd")))])]) : _vm._e()] : _vm._e(), _c("div", {
    staticStyle: {
      "padding-right": "60px",
      "flex-direction": "column"
    }
  }, _vm._l(_vm.productList, function (product, pi) {
    return _c("div", {
      key: pi,
      staticStyle: {
        margin: "12px 0",
        display: "flex"
      }
    }, [_c("span", {
      staticStyle: {
        "padding-right": "20px",
        width: "80px",
        display: "inline-block"
      }
    }, [_vm._v(" " + _vm._s(product.productNo) + " ")]), _c("span", {
      staticClass: "ellipsis-text",
      staticStyle: {
        "padding-right": "20px",
        width: "300px",
        display: "inline-block"
      }
    }, [_c("span", [_vm._v(_vm._s(product.productName))]), _c("div", [_vm._v(_vm._s(product.productOptionName))])]), !_vm.noticeSettingData || _vm.noticeSettingData && _vm.noticeSettingData.noticeflag !== 1 ? _c("span", [_c("a-popconfirm", {
      attrs: {
        title: _vm.$t("public.deletePromp"),
        "ok-text": _vm.$t("public.confirm"),
        "cancel-text": _vm.$t("public.cancel")
      },
      on: {
        confirm: function confirm($event) {
          return _vm.deleteProduct(product);
        }
      }
    }, [_c("a", [_vm._v(_vm._s(_vm.$t("public.delete")))])])], 1) : _vm._e(), !_vm.noticeSettingData || _vm.noticeSettingData && _vm.noticeSettingData.noticeflag !== 1 ? [_vm.productList.length - 1 == pi ? _c("span", [_c("a-divider", {
      attrs: {
        type: "vertical"
      }
    }), _c("a", {
      on: {
        click: function click($event) {
          return _vm.addProduct();
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("arrivalNotice.productAdd")))])], 1) : _vm._e()] : _vm._e()], 2);
  }), 0)], 2)]), _c("a-card", {
    staticStyle: {
      "margin-top": "24px",
      position: "relative",
      flex: "1 1 0%"
    },
    attrs: {
      id: "table",
      bordered: false,
      title: _vm.$t("arrivalNotice.noticeObject")
    }
  }, [_c("a-row", {
    attrs: {
      type: "flex",
      justify: "end"
    }
  }, [_c("a-col", [_c("a-button", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: _vm.addNoticeDyx
    }
  }, [_vm._v(_vm._s(_vm.$t("public.Add")))])], 1)], 1), _c("a-table", {
    attrs: {
      rowKey: "erpCustomerId",
      columns: _vm.noticeTableColumns,
      loading: _vm.noticeTableLoading,
      "data-source": _vm.dyxList,
      "row-selection": {
        onSelectAll: _vm.onNoticeTableSelectAll,
        onSelect: _vm.onNoticeTableSelect,
        onChange: _vm.onNoticeTableChange,
        selectedRowKeys: _vm.selectedRowKeys,
        hideDefaultSelections: true,
        getCheckboxProps: _vm.getCheckboxProps
      },
      pagination: {
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "30"],
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + _vm.listTotal;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.listTotal
      }
    },
    on: {
      change: _vm.noticeTableChange
    },
    scopedSlots: _vm._u([{
      key: "dyxInfo",
      fn: function fn(text, record) {
        return [_c("div", [_c("div", [_vm._v(_vm._s(record.erpCustomerCode))]), _c("div", {
          staticClass: "ellipsis-text",
          attrs: {
            title: record.erpCustomerName
          }
        }, [_vm._v(_vm._s(record.erpCustomerName))])])];
      }
    }, {
      key: "erpCustomerStatus",
      fn: function fn(text, record) {
        return [_c("a-tag", {
          attrs: {
            color: record.erpCustomerStatus === 1 ? "blue" : "red"
          }
        }, [_vm._v(" " + _vm._s(record.erpCustomerStatus == 1 ? _vm.$t("public.normal") : record.erpCustomerStatus == 2 ? _vm.$t("publicuse.delete") : _vm.$t("overSell2")) + " ")])];
      }
    }, {
      key: "busFormatName",
      fn: function fn(text, record) {
        return [_c("div", {
          staticClass: "ellipsis-text",
          attrs: {
            title: text || "--"
          }
        }, [_vm._v(_vm._s(text || "--"))])];
      }
    }, {
      key: "sellerName",
      fn: function fn(text, record) {
        return [_c("div", [_vm._v(_vm._s(text || "--"))])];
      }
    }, {
      key: "noticeType",
      fn: function fn(text, record) {
        return [_c("div", [_vm._v(_vm._s(_vm.noticeTypes[record.noticeType] || "--"))])];
      }
    }, {
      key: "noticeDate",
      fn: function fn(text, record) {
        return [_c("div", [_vm._v(_vm._s(text || "--"))])];
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return [!record.noticeDate ? _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.deletePromp"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.removeModal(record);
            }
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.delete")))])]) : _c("span", [_vm._v("--")])];
      }
    }])
  }), _c("div", {
    staticStyle: {
      "margin-top": "-50px"
    }
  }, [_c("span", {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.selected")) + _vm._s(_vm.selectNumber) + _vm._s(_vm.$t("public.term")))]), _c("span", {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.batchoperation")))]), _c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function click($event) {
        return _vm.removeClick();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("public.delete")))])], 1), _c("footer-tool-bar", [_c("a-button", {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      type: "primary",
      loading: _vm.noticeLoading
    },
    on: {
      click: _vm.handleMoreNotice
    }
  }, [_vm._v(_vm._s(_vm.$t("arrivalNotice.notice")))]), _c("a-button", {
    attrs: {
      loading: _vm.noticeSaveLoading,
      type: "primary"
    },
    on: {
      click: _vm.saveNotice
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.save")) + " ")])], 1)], 1), _c("a-modal", {
    staticClass: "addmodal",
    attrs: {
      title: _vm.$t("arrivalNotice.selectProduct"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.addProductVisible,
      callback: function callback($$v) {
        _vm.addProductVisible = $$v;
      },
      expression: "addProductVisible"
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.datavalue,
      rules: _vm.rules
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("publicuse.goodsno"),
      prop: "id"
    }
  }, [_c("a-select", {
    attrs: {
      "show-search": "",
      value: _vm.datavalue.id,
      placeholder: _vm.$t("public.enterPlease"),
      "default-active-first-option": false,
      "show-arrow": false,
      "filter-option": false
    },
    on: {
      search: _vm.handleSearch,
      change: _vm.handleChange
    }
  }, [_vm.addProductFetching ? _c("a-spin", {
    attrs: {
      slot: "notFoundContent",
      size: "small"
    },
    slot: "notFoundContent"
  }) : _vm._e(), _vm._l(_vm.addProudctList, function (item) {
    return _c("a-select-option", {
      key: item.id
    }, [_vm._v(" " + _vm._s(item.content) + " ")]);
  })], 2)], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.addProudctSaveLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.addNew();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")))])], 1)], 2), _c("a-modal", {
    attrs: {
      width: "430px",
      title: _vm.$t("batchDelete"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.removeTypeVisible,
      callback: function callback($$v) {
        _vm.removeTypeVisible = $$v;
      },
      expression: "removeTypeVisible"
    }
  }, [_c("a-form-model", {
    ref: "ruleRemoveForm",
    attrs: {
      model: _vm.modalValue
    }
  }, [_c("a-form-model-item", [_c("a-radio-group", {
    model: {
      value: _vm.modalValue.removeType,
      callback: function callback($$v) {
        _vm.$set(_vm.modalValue, "removeType", $$v);
      },
      expression: "modalValue.removeType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("arrivalNotice.selectDyx")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.currentpage")) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.allpage")) + " ")])], 1)], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.removeModalCancel();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.removeModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")) + " ")])], 1)], 2), _c("a-modal", {
    attrs: {
      width: "430px",
      title: _vm.$t("arrivalNotice.moreNotice"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.moreNoticeVisible,
      callback: function callback($$v) {
        _vm.moreNoticeVisible = $$v;
      },
      expression: "moreNoticeVisible"
    }
  }, [_c("a-form-model", {
    ref: "ruleRemoveForm",
    attrs: {
      model: _vm.moreNoticeForm
    }
  }, [_c("a-form-model-item", [_c("a-radio-group", {
    model: {
      value: _vm.moreNoticeForm.noticeType,
      callback: function callback($$v) {
        _vm.$set(_vm.moreNoticeForm, "noticeType", $$v);
      },
      expression: "moreNoticeForm.noticeType"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("arrivalNotice.selectDyx")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.currentpage")) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.allpage")) + " ")])], 1)], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.moreNoticeCancel();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.noticeDyxLoading
    },
    on: {
      click: function click($event) {
        return _vm.moreNotice();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")) + " ")])], 1)], 2), _c("selectGroupVue", {
    ref: "selectModal",
    attrs: {
      alreadySelect: _vm.alreadySelect
    },
    on: {
      confirmProduct: _vm.confirmProduct
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };